module.exports = __webpack_public_path__ + "img/spain-other-heart-diseases-female.77e21a15.png";